import React from "react";
import { getValue } from "@utils/lodash";

function AssignedTaskDueDateSvgComponent(props: any) {
  return (
      <svg xmlns="http://www.w3.org/2000/svg" 
      height={
        getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
      }
      width={
        getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
      }
       viewBox="0 0 18 18">
        <defs>
          <clipPath id="clip-path-due-dates">
            <rect id="Rectangle_18127" data-name="Rectangle 18127" width="18" height="18" transform="translate(-12072 -6438)" fill="#fff"/>
          </clipPath>
        </defs>
        <g id="Mask_Group_239" data-name="Mask Group 239" transform="translate(12072 6438)" clip-path="url(#clip-path-due-dates)">
          <path id="event_FILL0_wght300_GRAD0_opsz24" d="M12.184-8.1a1.779,1.779,0,0,1-1.3-.527,1.736,1.736,0,0,1-.534-1.283,1.736,1.736,0,0,1,.534-1.283,1.779,1.779,0,0,1,1.3-.527,1.779,1.779,0,0,1,1.3.527,1.736,1.736,0,0,1,.534,1.283,1.736,1.736,0,0,1-.534,1.283A1.779,1.779,0,0,1,12.184-8.1ZM4.731-5.354a1.394,1.394,0,0,1-1.019-.412A1.361,1.361,0,0,1,3.3-6.773v-10.5a1.361,1.361,0,0,1,.417-1.007,1.394,1.394,0,0,1,1.019-.412h1.1v-1.66H7.053v1.66H13.07v-1.66h1.191v1.66h1.1a1.394,1.394,0,0,1,1.019.412,1.361,1.361,0,0,1,.417,1.007v10.5a1.361,1.361,0,0,1-.417,1.007,1.394,1.394,0,0,1-1.019.412Zm0-1.177H15.36a.235.235,0,0,0,.168-.075.23.23,0,0,0,.076-.166v-7.364H4.487v7.364a.23.23,0,0,0,.076.166A.235.235,0,0,0,4.731-6.531Zm-.244-8.783H15.6v-1.962a.23.23,0,0,0-.076-.166.235.235,0,0,0-.168-.075H4.731a.235.235,0,0,0-.168.075.23.23,0,0,0-.076.166v1.962Zm0,0v0Z" transform="translate(-12073.046 -6416.146)" fill={
          getValue(props, `color`, "") ? getValue(props, `color`, "") : "#5f6368"
        } />
        </g>
      </svg>
  );
}

export default AssignedTaskDueDateSvgComponent;
